// extracted by mini-css-extract-plugin
module.exports = {"avatars":"_93444fe79c--avatars--_MZr4","primary":"_93444fe79c--primary--Iw0n2","secondary":"_93444fe79c--secondary--LCZvi"};